export const getQueryParam = (
  param: string,
  search: string = window.location.search
): string => {
  const params = new URLSearchParams(search);
  return params.get(param) || '';
};
